import { useState } from "react";
import client from "../api/client";


const styles = {
  card: { border: 0, borderRadius: 14, boxShadow: "0 2px 10px rgba(0,0,0,.08)", overflow: "hidden", background: "#fff" },
  header: { background: "linear-gradient(90deg,#0b4f4a,#0f766e)", color: "#fff", padding: "9px 12px" },
  title: { fontSize: 13, fontWeight: 700, margin: 0 },
  sub: { fontSize: 10, opacity: .85 },
  body: { padding: 12, fontSize: 11 },
  filterBox: { background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 12, padding: 10, marginBottom: 10 },
  label: { fontSize: 10, fontWeight: 700, marginBottom: 3, color: "#495057" },
  input: { height: 30, fontSize: 11, borderRadius: 7 },
  btn: { height: 30, fontSize: 11, borderRadius: 7, fontWeight: 600 },
  th: { fontSize: 10, padding: "7px 8px", whiteSpace: "nowrap", color: "#fff", background: "#07111f" },
  td: { fontSize: 11, padding: "6px 8px", verticalAlign: "middle", whiteSpace: "nowrap" },
  longTd: { fontSize: 11, padding: "6px 8px", verticalAlign: "middle", minWidth: 260, whiteSpace: "normal" },
  badge: { fontSize: 10, padding: "4px 7px", borderRadius: 20, fontWeight: 600 },
};


export default function DeletedEntriesPage() {
  const [filter, setFilter] = useState({fromDate: "", toDate: "", tableName: "", deletedBy: ""});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const set = (key, value) => setFilter((p) => ({ ...p, [key]: value }));
  const formatDate = (value) => value ? String(value).replace("T", " ").slice(0, 19) : "-";
  const qs = () => new URLSearchParams(Object.fromEntries(Object.entries(filter).filter(([_, v]) => v))).toString();

  const load = async () => {
    setLoading(true);
    try {
      const res = await client.get(`/audittrail/deleted-entries?${qs()}`);
      setRows(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setFilter({fromDate: "", toDate: "", tableName: "", deletedBy: ""});
    setRows([]);
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <h6 style={styles.title}><i className="bi bi-trash3 me-2"></i>Deleted Entry Tracking</h6>
        <div style={styles.sub}>Review deleted records with old data snapshots for recovery and audit</div>
      </div>
      <div style={styles.body}>
        <div style={styles.filterBox}>
          <div className="row g-2">
            <div className="col-md-2">
              <label style={styles.label}>From</label>
              <input type="date" className="form-control form-control-sm" style={styles.input} value={filter.fromDate} onChange={(e) => set("fromDate", e.target.value)} placeholder="From" />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>To</label>
              <input type="date" className="form-control form-control-sm" style={styles.input} value={filter.toDate} onChange={(e) => set("toDate", e.target.value)} placeholder="To" />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>Table</label>
              <input type="text" className="form-control form-control-sm" style={styles.input} value={filter.tableName} onChange={(e) => set("tableName", e.target.value)} placeholder="Table" />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>Deleted By</label>
              <input type="text" className="form-control form-control-sm" style={styles.input} value={filter.deletedBy} onChange={(e) => set("deletedBy", e.target.value)} placeholder="Deleted By" />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary btn-sm w-100" style={styles.btn} onClick={load} disabled={loading}>
                <i className="bi bi-search me-1"></i>{loading ? "Loading..." : "Load"}
              </button>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-outline-secondary btn-sm w-100" style={styles.btn} onClick={clear}>
                <i className="bi bi-x-circle me-1"></i>Clear
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between mb-2" style={{fontSize: 10, color: "#6c757d"}}>
          <span><i className="bi bi-database me-1"></i>Total Records: <strong>{rows.length}</strong></span>
          <span>Security monitoring</span>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table className="table table-sm table-hover align-middle mb-0">
            <thead><tr>
                <th style={styles.th}>Date</th>
                <th style={styles.th}>Deleted By</th>
                <th style={styles.th}>Table</th>
                <th style={styles.th}>Record Id</th>
                <th style={styles.th}>Reason</th>
                <th style={styles.th}>Old Data</th>
                <th style={styles.th}>IP</th></tr></thead>
            <tbody>
              {rows.length ? rows.map((r, i) => (
                <tr key={i}>
                    <td style={styles.td}>formatDate(r.deletedAt || r.DeletedAt || r.createdAt || r.CreatedAt)</td>
                    <td style={styles.td}>r.deletedBy || r.DeletedBy || r.userName || r.UserName || "-"</td>
                    <td style={styles.td}>r.tableName || r.TableName || "-"</td>
                    <td style={styles.td}>r.recordId || r.RecordId || "-"</td>
                    <td style={styles.longTd}>r.reason || r.Reason || "-"</td>
                    <td style={styles.longTd}>r.oldData || r.OldData || "-"</td>
                    <td style={styles.td}>r.ipAddress || r.IpAddress || "-"</td>
                </tr>
              )) : (
                <tr><td colSpan="7" className="text-center text-muted" style={{...styles.td, padding: 18}}>No records found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
